import doc                      from '@widesk-core/decorators/doc';
import AbstractContactTypeModel from './AbstractContactTypeModel';
import { Translatable }         from '@widesk-core/decorators/translatable';

@doc.urnResource('contact_type')
@doc.translatable({ label: true })
class ContactTypeModel extends AbstractContactTypeModel {}

interface ContactTypeModel
	extends Translatable<{ label: true }> {
}

export default ContactTypeModel;